import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { Context } from 'context/context';
import { COPY } from 'data/errors';

import styles from "dashboard/projects/project/Project.module.scss";

// The list's labels for the in-flight states (List.js); anything else in flight, `new` included, reads as Queued.
const LABELS = {
    waiting_to_be_sent_to_tuner: "Queued",
    waiting_for_identification: "Identifying Protocol",
    waiting_for_map_data: "Generating Map Packs",
};

/**
 * The project panel for a project the API is still preparing. The provider polls /status and keeps the list item current, so this
 * screen only reads `project` (the list item). `takingLonger` is set after 3 minutes without a settled state.
 */
class Processing extends Component {
    static contextType = Context;

    refresh = async () => {
        try {
            await this.context.getProjects({quiet: true});
        } catch(error) {
            // a quiet refresh says nothing and does not throw; the line stays until the poll or the next list shows a change
        }
    };

    render() {
        const project = this.props.project;
        return (
            <>
                <div className={`bgTertiary highlightTertiary ${styles.activation}`}>
                    <div>
                        <NavLink to={`/projects`} className={styles.cross}>
                            <img src={require(`images/icons/${this.context.lightTheme ? "cross-dark" : "cross"}.svg`)} alt={"X"} />
                        </NavLink>
                        <p className={styles.sub}>{COPY.dash.processing.title}</p>
                    </div>
                </div>

                <div className={`bgSecondary ${styles.content}`}>
                    <div className={styles.alert}>
                        <div>
                            <p className="txtPrimary"><b>{LABELS[project.tunerStatus] || LABELS.waiting_to_be_sent_to_tuner}</b></p>
                            <p className="txtSecondary">{COPY.dash.processing.body}</p>
                            {project.takingLonger &&
                                <p className="txtSecondary">
                                    {COPY.dash.takingLonger}{" "}
                                    <a href="#refresh" onClick={(e) => { e.preventDefault(); this.refresh(); }}>{COPY.dash.refresh}</a>
                                </p>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Processing;
